// App Download Bottomsheet controller
// Opens the bottomsheet (registered by snippets/app-download-bottomsheet.liquid via the
// shared component-bottomsheet.js BottomsheetManager) on iOS mobile, when not loaded
// inside the MaiApp WebView, when the user hasn't already dismissed it, and when at
// least 20 cumulative seconds have passed since the user first opened the shop.
//
// The 20 s timer is global (persisted in localStorage) — it accrues across page loads
// and across the user's visit, not just the current page. So the sheet opens when the
// user lands on or stays on the homepage after the timer elapses, regardless of which
// page they originally entered the shop on.

(function () {
  var DISMISSED_KEY = 'app-download-bottomsheet-dismissed';
  var TIMER_START_KEY = 'app-download-bottomsheet-timer-start';
  var SHOW_AFTER_MS = 20 * 1000;
  var BOTTOMSHEET_ID = 'app-download';
  var SURFACE = 'app_download_prompt';

  var secondsToShow = null;

  function isAppMode() {
    if (document.documentElement.classList.contains('app-mode')) return true;
    try {
      return sessionStorage.getItem('app-mode') === '1';
    } catch {
      return false;
    }
  }

  function isIOS() {
    var ua = navigator.userAgent || '';
    // iPad on iPadOS 13+ reports as Macintosh; the touch-points heuristic catches it.
    var isIpadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    return /iPad|iPhone|iPod/.test(ua) || isIpadOS;
  }

  function isAndroid() {
    return /Android/i.test(navigator.userAgent || '');
  }

  function isHomepage() {
    var path = window.location.pathname;
    // Shopify storefront homepage is "/" — locale prefixes ("/en", "/sv-se") map to /.
    return path === '/' || /^\/[a-z]{2}(-[a-z]{2})?\/?$/i.test(path);
  }

  function wasDismissed() {
    try {
      return localStorage.getItem(DISMISSED_KEY) === '1';
    } catch {
      return false;
    }
  }

  function markDismissed() {
    try {
      localStorage.setItem(DISMISSED_KEY, '1');
    } catch {
      // localStorage not available; nothing else we can do.
    }
  }

  function getOrInitTimerStart() {
    try {
      var existing = localStorage.getItem(TIMER_START_KEY);
      if (existing) {
        var parsed = parseInt(existing, 10);
        if (!isNaN(parsed)) return parsed;
      }
      var now = Date.now();
      localStorage.setItem(TIMER_START_KEY, String(now));
      return now;
    } catch {
      // localStorage unavailable; fall back to per-page-load behavior.
      return Date.now();
    }
  }

  function timeUntilShowMs() {
    var elapsed = Date.now() - getOrInitTimerStart();
    return Math.max(0, SHOW_AFTER_MS - elapsed);
  }

  function baseProps(extra) {
    var props = {
      surface: SURFACE,
      locale: (document.documentElement.lang || '').toLowerCase() || null,
      seconds_to_show: secondsToShow
    };
    if (extra) {
      for (var k in extra) props[k] = extra[k];
    }
    return props;
  }

  // Wait up to MAX_TRACK_WAIT_MS for window.MaiAnalytics to be defined before
  // firing. Without this poll, the Shown event silently drops on sessions where
  // analytics-helpers.js (loaded via `defer`) hasn't initialised by the time
  // the bottomsheet opens — which Mixpanel data showed produces ~30% more
  // Dismiss events than Shown events because Dismiss fires later, after
  // MaiAnalytics has loaded.
  var MAX_TRACK_WAIT_MS = 2000;
  var TRACK_POLL_MS = 50;

  function track(name, extra) {
    var props = baseProps(extra);
    var elapsed = 0;
    function tryFire() {
      try {
        if (window.MaiAnalytics && typeof window.MaiAnalytics.track === 'function') {
          window.MaiAnalytics.track(name, props);
          return;
        }
      } catch {
        return; // MaiAnalytics threw; give up silently.
      }
      elapsed += TRACK_POLL_MS;
      if (elapsed >= MAX_TRACK_WAIT_MS) return;
      setTimeout(tryFire, TRACK_POLL_MS);
    }
    tryFire();
  }

  function open() {
    var fn = window.open_app_download;
    if (typeof fn !== 'function') return;
    secondsToShow = Math.round((Date.now() - getOrInitTimerStart()) / 1000);
    fn();
    track('App Download Prompt Shown');
    bindCloseHandlers();
  }

  function bindCloseHandlers() {
    var overlay = document.getElementById(BOTTOMSHEET_ID + '-overlay');
    if (!overlay) return;

    var closeBtn = overlay.querySelector('[data-bottomsheet-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        markDismissed();
        track('App Download Prompt Dismissed', { dismiss_method: 'close_button' });
      });
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        markDismissed();
        track('App Download Prompt Dismissed', { dismiss_method: 'overlay' });
      }
    });

    var cta = overlay.querySelector('[data-app-download-cta]');
    if (cta) {
      if (isAndroid()) {
        cta.href = 'https://play.google.com/store/apps/details?id=se.maiapp.app.prod';
      }
      cta.addEventListener('click', function () {
        markDismissed();
        track('App Download Prompt Clicked');
      });
    }
  }

  function maybeSchedule() {
    if (isAppMode()) return;
    if (!isIOS() && !isAndroid()) return;
    if (wasDismissed()) return;

    // Always start the global timer on any shop page so cumulative time accrues
    // across the visit. The bottomsheet itself only opens on the homepage.
    getOrInitTimerStart();

    if (!isHomepage()) return;

    var remaining = timeUntilShowMs();
    if (remaining <= 0) {
      open();
      return;
    }
    setTimeout(function () {
      if (wasDismissed()) return;
      open();
    }, remaining);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeSchedule);
  } else {
    maybeSchedule();
  }
})();
